import React, { useState, useEffect } from "react";
import { Button, Text, Icon, Accordion,Tooltip, Dialog } from "@ui-component-library";
import ReviewSlider from "../ReviewSlider";

  {/* Hero section */}
const HeroSection =({title,paragraph,heroButtonOne,heroButtonTwo, image})=>{
    return(
          <div className="bg-cloud-50">
            <div className="container">
                <>     
                    <div className="grid grid-cols-1 lg:grid-cols-2 px-6 gap-16 py-24">
                        <div className="grid grid-row content-center order-2 lg:order-1">
                            <div className="grid grid-row gap-6">
                                <Text variant="text-4xl/leading-none/medium">{title}</Text>
                                <Text variant="text-lg/leading-normal/normal" className="text-[#737373]">{paragraph}</Text>
                            </div>
                            <div className="pt-8 flex justify-start gap-4">
                                <Button
                                    onClick={heroButtonOne.onClick}
                                    variant="outline"
                                >
                                    {heroButtonOne.text}
                                </Button>
                                <Button
                                    onClick={heroButtonTwo.onClick}
                                    variant="primary"
                                > <>
                                        {heroButtonTwo.text}
                                        <Icon
                                            className="fill-white-50"
                                            name="ArrowRightSimple"
                                        />
                                    </>

                                </Button>
                            </div>
                        </div>
                        <div className='order-1 lg:order-2 flex justify-center'>
                            {image}
                        </div>
                    </div>                 
                </>
            </div>
        </div>
    )

}

{/* Bento section */}
const BentoCard = ({ img, title, paragraph}) => {
        return (
            <div className="flex min-h-0 flex-col h-full rounded-xl overflow-hidden">
                <div className="h-[336px] w-full shrink-0 overflow-hidden">
                    {img}
                </div>
                <div className="min-h-0 flex flex-1 flex-col gap-2 bg-cloud-200 p-6">
                    <Text variant="text-lg/leading-normal/medium">{title}</Text>
                    {paragraph}
                </div>
            </div>
        )
    }

const BentoSection =({title,paragraph,children})=>{
   return( <div className="bg-cloud-50">
            <div className="container ">
                <>
                    <div className="py-24 px-6">
                        <div className="flex justify-center">
                            <div className="w-[576px] flex flex-col gap-5 ">
                                <Text variant="text-3xl/leading-normal/medium" className="text-center">{title}</Text>
                                {paragraph}
                            </div>
                        </div>                
                        {children}
                      
                    </div>
                </>
            </div>
        </div>)
}

{/* Customer testimonials section */}
const CustomerTestimonialSection = () => {
   return( <div style={{ backgroundColor: '#E5E1DC' }}>
        <div className="container">
            <>
                <div className="py-24 xl:px-20">
                    <ReviewSlider />
                </div>
            </>
        </div>
    </div>)
}

{/*CTA section*/}
const CTASection = ({title, paragraph, ctaButton, secondaryCtaButton}) =>{
    return(
        <div style={{ backgroundColor: '#0F0F0F' }}>
            <div className="container ">
                <>
                    <div className="py-24 px-6 flex justify-center">
                        <div className="flex flex-col text-white text-center gap-5 max-w-[576px]">
                            <Text variant="text-3xl/leading-normal/medium">{title}</Text>
                            {paragraph}
                            <div className="flex justify-center mt-5 gap-4">
                                {secondaryCtaButton && <Button variant="outline" className="text-white-50" onClick={secondaryCtaButton?.onClick}>
                                    {secondaryCtaButton?.text}
                                </Button>}

                                <Button variant="outline" className="bg-white hover:text-white" onClick={ctaButton.onClick}><>
                                    {ctaButton?.text}
                                    <Icon
                                        name="ArrowRightSimple"
                                    />

                                </></Button>
                            </div>
                        </div>
                    </div>
                </>
            </div>

        </div>)
}

{/*Pricing section*/}
const PricingCard = ({ title, priceCardButton, features, backgroundColor = "white"}) => {
    const [openDialog, setOpenDialog] = useState({state:false,text:"",details:""})
    const [isTablet, setIsTablet] = useState(window.innerWidth < 1024);

     useEffect(() => {
            const handleResize = () => setIsTablet(window.innerWidth < 1024);
            window.addEventListener("resize", handleResize);
            return () => window.removeEventListener("resize", handleResize);
        }, []);
    

    return (<><div className={`p-8 rounded-xl border border-solid shadow-xl w-[325.33px] ${backgroundColor === "black" ? "bg-black border-white" : "bg-white border-[#E6E6E6]"}`}>
        <Text variant="text-lg/leading-normal/semibold" className={`${backgroundColor === "black" ? "text-white" : ""} text-start mb-6`}>{title}</Text>
        {priceCardButton?.state && <Button variant={`${backgroundColor == "black" ? "outline" : "primary"}`} className={`${backgroundColor == "black" ? "bg-white hover:text-white" : ""} mb-8 w-full`}
            onClick={priceCardButton?.onClick}>{priceCardButton?.text}</Button>}
        <Text variant="text-sm/leading-normal/medium" className={`${backgroundColor === "black" ? "text-white" : ""} text-start`}>{features.subtitle}</Text>
        {features.info.map((feature, index) => {
            return (
                !isTablet ?
                    <Tooltip
                        key={index}
                        aria-label={feature.text}
                        content={<><Text variant="text-sm/leading-normal/normal">{feature.text}</Text><Text variant="text-sm/leading-normal/normal">{feature.details}</Text></>}>
                        <div className="flex justify-between items-center mt-6">
                            <div className="flex justify-start">
                                <Icon name="CheckSimple" className={`${backgroundColor == "black" ? "fill-white" : ""} mr-4`} />
                                <Text variant="text-sm/leading-normal/normal" className={`${backgroundColor === "black" ? "text-white" : ""} text-start `}>{feature.text}</Text>
                            </div>
                            <Icon name="InfoOutlined" className={`${backgroundColor == "black" ? "fill-white" : ""}`} />
                        </div> </Tooltip> :
                    <div key={index} className="flex justify-between items-center mt-6" onClick={() => { setOpenDialog({state:true, text:feature.text,details:feature.details}) }}>
                        <div className="flex justify-start">
                        <p>horse</p>
                            <Text variant="text-sm/leading-normal/normal" className={`${backgroundColor === "black" ? "text-white" : ""} text-start `}>{feature.text}</Text>
                        </div>
                        <Icon name="InfoOutlined" className={`${backgroundColor == "black" ? "fill-white" : ""}`} />
                    </div>)
        })}
    </div>
        <Dialog isOpen={openDialog.state} size='small'>
            <Dialog.Header className="justify-between items-center">
                <Text variant="text-sm/leading-normal/normal">{openDialog?.text}</Text>
                <Button variant="outline" size="icon" onClick={() => setOpenDialog({ state: false })}>
                    <Icon name="CrossSimple" className="fill-charcoal-500" size="medium" />
                </Button></Dialog.Header>
            <Dialog.Content><Text variant="text-sm/leading-normal/normal">{openDialog?.details}</Text></Dialog.Content>
        </Dialog></>)

    }

const PricingSection =({title,paragraph, children})=>{
    return (<div className="bg-cloud-50">
            <div className="container ">
                    <>
                    <div className="py-24 md:px-6">
                        <div className="flex justify-center">
                            <div className="w-[576px] flex flex-col gap-5 mb-8">
                                <Text variant="text-3xl/leading-normal/medium" className="text-center">{title}</Text>
                                {paragraph}
                            </div>
                        </div>
                       {children}
                    </div>
                </>
            </div>

        </div>)
}

 {/* FAQ section */}
const FAQComponent = ({ question, answer }) => {
        return (
            <Accordion className="border-b border-solid border-[#E6E6E6] py-6">
                <Accordion.Header>
                    <Text variant="text-sm/leading-normal/medium">{question}</Text>
                </Accordion.Header>
                <Accordion.Content>{answer}</Accordion.Content>
            </Accordion>
        )
    }
   
const FAQSection = ({title,paragraph,children})=>{
    return(       
        <div className="bg-cloud-50">
            <div className="container ">
                <>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-16 py-24 px-6">
                        <div className="flex flex-col justify-start gap-lg">
                            {/* <Text variant="text-sm/leading-normal/medium" className="text-[#737373]">FAQ section</Text> */}
                            <Text variant="text-3xl/leading-normal/medium">{title}</Text>
                            <Text variant="text-base/leading-normal/normal" className="text-[#737373]">{paragraph}</Text>
                        </div>
                        <div>
                            {children}
                        </div>

                    </div>
                </>
            </div>
        </div>
    )
}

export {HeroSection, BentoCard, BentoSection,CustomerTestimonialSection,CTASection,PricingCard,PricingSection,FAQComponent,FAQSection}
